import React from 'react';
import {history} from '../../redux/store';

const HomeView = () => (
    <div className="text-justify">
        6. Вітаємо Вас в особистому кабінеті! Тут Ви можете&nbsp;
        <a className="text-danger" onClick={() => history.push('/food')}>замовити харчування</a>,
        а також переглянути та роздрукувати&nbsp;
        <a className="text-danger" onClick={() => history.push('/finance')}>квитанції на оплату</a>  за навчання дитини.<br/>
        <br/>
        Просимо Вас надсилати відгуки про роботу особистого кабінету, а також Ваші побажання та повідомлення про помилки,
        додаючи скріншот помилки, на адресу&nbsp;
        <a className="text-danger" href="mailto:develop@athens.kiev.ua">develop@athens.kiev.ua</a>
    </div>
);

export default HomeView;



/** WEBPACK FOOTER **
 ** ./src/modules/home/HomeView.js
 **/